import { CLASS_SLIDE } from '@splidejs/splide';


export const CLASS_SLIDE_ROW = `${ CLASS_SLIDE }__row`;
export const CLASS_SLIDE_COL = `${ CLASS_SLIDE }--col`;
